<template>
    <div v-if="tags && tags.length > 0" class="flex flex-wrap gap-2">
        <NuxtLink
            v-for="tag in tags"
            :key="tag"
            :to="`/blog?tag=${encodeURIComponent(tag)}`"
            class="inline-block px-3 py-1 text-sm font-medium bg-gray-100 dark:bg-subtle text-gray-700 dark:text-txt-body rounded-full hover:bg-primary-100 hover:dark:bg-primary-950/40 hover:text-primary-700 hover:dark:text-primary-300 transition-colors"
        >
            #{{ tag }}
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    tags: string[]
}>()
</script>
